export enum TableId {
  Documents = 'documents',
  VirtualDocuments = 'virtual-documents',
  Locations = 'locations',
  Tickets = 'tickets',
  Contracts = 'contracts',
  InvoiceDetails = 'invoice-details',
  Vendors = 'vendors',
  SubsidiaryOrganizations = 'subsidiary-organizations',
  BillingSummary = 'billing-summary',
  Savings = 'savings',
}
